import { WsSelect, LoaderIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';

const JobStatusFilter = ({
  name,
  title = 'Job Status',
  isAmAnalytics = false,
  showAccordionIcon,
}: WsFilterProps) => {
  const startIcon = showAccordionIcon ? <LoaderIcon /> : null;

  const jobStatusOptions = [
    {
      value: 'Opened',
      label: 'Open',
    },
    {
      value: 'Closed',
      label: 'Closed',
    },
    {
      value: isAmAnalytics ? 'Any' : 'openAndClosed',
      label: 'Open And Closed',
    },
  ];
  return (
    <WsAccordion title={title} startIcon={startIcon}>
      <WsSelect name={name} selectArray={jobStatusOptions} placeholder="Select" />
    </WsAccordion>
  );
};
export default JobStatusFilter;
